export const baseSanityConfig = {
  projectId: 'zlvi57ho',
  dataset: process.env.REACT_APP_STAGE === 'prod' ? 'production' : 'development',
};
